module.exports = __webpack_public_path__ + "9cd1e7874ef398a7a1e7f34b09e93da0.svg";